import { render, staticRenderFns } from "./buttonAssignDriver.vue?vue&type=template&id=20760231"
import script from "./buttonAssignDriver.vue?vue&type=script&lang=ts"
export * from "./buttonAssignDriver.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports